export const PATH_STRATEGY_PLANNING = "strategy-planning";
export const PATH_KPI_LIBRARY_GENERATOR = "KPI-generator";
